module.exports = __webpack_public_path__ + "static/media/logo.bfceea9c.png";